import React from 'react';
import PropTypes from 'prop-types';
import { Circle, Map, Marker, TileLayer } from 'react-leaflet';
import Leaflet from 'leaflet';
import 'leaflet/dist/leaflet.css';
import marker from '../../assets/images/Marker/blueMarker.png';

const icon = Leaflet.icon({
  iconUrl: marker,
  // iconSize: [38, 95], // size of the icon
  // shadowSize: [50, 64], // size of the shadow
  iconAnchor: [13.5, 41], // point of the icon which will correspond to marker's location
  // shadowAnchor: [4, 62],  // the same for the shadow
  // popupAnchor: [-3, -76]// point from which the popup should open relative to the iconAnchor
});

class Maps extends React.Component {
  constructor() {
    super();
    this.state = {
      zoom: 5,
      draggable: true,
      position: null,
    };
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.position) {
      this.setState({ position: newProps.position });
    }
  };

  toggleDraggable = () => {
    this.setState({ draggable: !this.state.draggable });
  };

  updatePosition = () => {
    const { lat, lng } = this.refs.marker.leafletElement.getLatLng();
    this.setState({
      position: { lat, lng },
    });
    this.props.handlePosition(this.state.position);
  };

  render() {
    const { zoom, draggable } = this.state;
    const { position, radius,zoomPosition } = this.props;

    return (
      <div id="container">
        <Map
          center={position}
          zoomControl={false}
          zoom={zoomPosition? 50:5}
          onzoom={event => this.setState({ zoom: event.target._zoom })}
          style={{ height: 530, margin: '0 auto' }}
        >
          <TileLayer
            attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker
            draggable={draggable}
            onDragend={this.updatePosition}
            position={position}
            icon={icon}
            ref="marker"
          />
          <Circle
            center={position}
            fillColor="blue"
            radius={radius ? Number(radius) : 200}
            draggable={draggable}
            onDragend={this.updatePosition}
          />
        </Map>
      </div>
    );
  }
}

Maps.propTypes = {
  position: PropTypes.array,
  handlePosition: PropTypes.func.isRequired,
  radius: PropTypes.number,
};

Maps.defaultProps = {
  position: [-15.797466386386164, -47.8934222345034],
  radius: 200,
};

export default Maps;
